'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLayout = exports.parseCombination = exports.getConceptsSet = undefined;
var _set = require('babel-runtime/core-js/set');
var _set2 = _interopRequireDefault(_set);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getConceptsSet = exports.getConceptsSet = function getConceptsSet(ids, indexedCombinations, _upper) {
  var upper = R.isNil(_upper) ? new _set2.default([]) : _upper;
  var res = new _set2.default([]);
  R.forEach(function (id) {
    if (!R.has(id, indexedCombinations)) {
      res.add(id);
    } else {
      var comb = R.prop(id, indexedCombinations);
      R.forEach(function (c) {
        if (!upper.has(c)) {
          res.add(c);
        }
      }, comb.concepts);
    }
  }, ids);
  return res;
};
var parseCombination = exports.parseCombination = function parseCombination(_upperIds, _excludedIds) {
  return function (comb, indexedDimensions) {
    var upperIds = R.isNil(_upperIds) ? new _set2.default([]) : _upperIds;
    var excludedIds = R.isNil(_excludedIds) ? new _set2.default([]) : _excludedIds;
    var concepts = comb.concepts,
      relationship = comb.relationship;
    var dimensions = R.reduce(function (acc, id) {
      if (upperIds.has(id) || !R.has(id, indexedDimensions)) {
        return acc;
      }
      var dim = R.prop(id, indexedDimensions);
      return R.append(dim, acc);
    }, [], concepts);
    var excludedDep = R.find(function (i) {
      return excludedIds.has(i);
    }, relationship);
    if (excludedDep) {
      return dimensions;
    }
    return R.assoc('dimensions', dimensions, comb);
  };
};
var getLayout = exports.getLayout = function getLayout(_layoutIds, dimensions, combinations, isTimeInverted) {
  var layoutIds = R.mergeRight({
    header: [],
    sections: [],
    rows: []
  }, _layoutIds);
  var applyInversionOnTimeDim = function applyInversionOnTimeDim(dim) {
    return (0, _dotstatsuiteSdmxjs.isTimePeriodDimension)(dim) && isTimeInverted ? R.assoc('isInverted', true, dim) : dim;
  };
  var indexedDimensions = R.reduce(function (acc, dim) {
    return R.assoc(dim.id, applyInversionOnTimeDim(dim), acc);
  }, {}, dimensions);
  var indexedCombinations = R.indexBy(R.prop('id'), combinations);
  var headerConceptsSet = getConceptsSet(layoutIds.header, indexedCombinations);
  var sectionsConceptsSet = getConceptsSet(layoutIds.sections, indexedCombinations);
  var rowsConceptsSet = getConceptsSet(R.concat(layoutIds.sections, layoutIds.rows), indexedCombinations);
  var getLayoutLevel = function getLayoutLevel(_upperIds, _excludedIds) {
    return function (ids) {
      return R.reduce(function (acc, id) {
        if (R.has(id, indexedDimensions)) {
          var dim = R.prop(id, indexedDimensions);
          return R.append(dim, acc);
        }
        if (!R.has(id, indexedCombinations)) {
          return acc;
        }
        var comb = R.prop(id, indexedCombinations);
        var parsedCombination = parseCombination(_upperIds, _excludedIds)(comb, indexedDimensions);
        if (R.is(Array, parsedCombination)) {
          return R.concat(acc, parsedCombination);
        }
        return R.append(parsedCombination, acc);
      }, [], ids);
    };
  };
  var header = getLayoutLevel(null, rowsConceptsSet)(layoutIds.header);
  var sections = getLayoutLevel(null, headerConceptsSet)(layoutIds.sections);
  var rows = getLayoutLevel(sectionsConceptsSet, headerConceptsSet)(layoutIds.rows);
  return {
    header: header,
    sections: sections,
    rows: rows
  };
};